import SearchAndSortableTable from '../../../../../../../components/table/SearchAndSortableTable';
import './TeacherTableSelector.scss';

const tableConfig = [
  {
    title: 'First Name',
    align: 'left',
    dataField: 'firstName',
    width: '28%',
    dataRenderer: (data) => <span data-dd-privacy='mask'>{data.firstName}</span>,
  },
  {
    title: 'Last Name',
    align: 'left',
    dataField: 'lastName',
    width: '29%',
    dataRenderer: (data) => <span data-dd-privacy='mask'>{data.lastName}</span>,
  },
  {
    title: 'Username',
    align: 'left',
    dataField: 'username',
    width: '43%',
    dataRenderer: (data) => <span data-dd-privacy='mask'>{data.username}</span>,
  },
];

const TeacherTableSelector = ({
  studentTeacherSelectorTableData,
} = {
  studentTeacherSelectorTableData: {},
}) => (
  <div className='teacher-table-selector'>
    <SearchAndSortableTable
      containerClassName='teacher-selector-table'
      config={tableConfig}
      tableData={studentTeacherSelectorTableData}
      searchPlaceholder='Search your Teachers'
      initTableState={{
        order: 'desc',
        orderBy: 'firstName',
      }}
      searchFunction={(keyword, data) => {
        const name = `${data.firstName} ${data.lastName}`;
        const isNameMatched = name.toLowerCase().indexOf(keyword.toLowerCase()) >= 0;
        const isEmailMatched = data.username.toLowerCase().indexOf(keyword.toLowerCase()) >= 0;
        return isNameMatched || isEmailMatched;
      }}
      autoResetTableState={false}
    />
  </div>
);

export default TeacherTableSelector;
